import { render, staticRenderFns } from "./DoYouWantToAddThisPointToRide.vue?vue&type=template&id=0a9843fe&scoped=true"
import script from "./DoYouWantToAddThisPointToRide.vue?vue&type=script&lang=js"
export * from "./DoYouWantToAddThisPointToRide.vue?vue&type=script&lang=js"
import style0 from "./DoYouWantToAddThisPointToRide.vue?vue&type=style&index=0&id=0a9843fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9843fe",
  null
  
)

export default component.exports